/// <reference path='../../../../../common/types/okta.ts' />
import * as React from 'react';
import { useState } from 'react';
import { ContentPanel } from '@enginuity-apps-ui-components/atoms/content-panel/content-panel';
import GenericErrorMessage from '../../components/misc/generic-error-message';
import { UserService } from '@enginuity-common/services/userService';
import RequestPasswordResetForm from '../../components/registration/request-password-reset-form';
import CheckEmail from '../../components/misc/check-email';
import { SpinnerOverlay } from '@enginuity-apps-ui-components/atoms/spinner/spinner';
import { SettingsForApp } from '../../apps';

export type IForgotPassword = {
  email?: string;
  username?: string;
};

export type IForgotPasswordProps = {
  fromUri: string;
  appName: string;
  settingsForApp: SettingsForApp;
};

export default function ForgotPassword({fromUri, appName, settingsForApp}: IForgotPasswordProps) {
  const [submitError, setSubmitError] = useState<JSX.Element | undefined>();
  const [genericError, setGenericError] = useState<string | undefined>();
  const [resetFormData, setResetFormData] = useState<IForgotPassword>();
  const [showSpinner, setShowSpinner] = useState(false);
  const [showEmailSent, setEmailSent] = useState(false);

  const userService = new UserService({
    baseUrl: window.spConfig.usersBaseUrl
  });

  const saveForm = async (data: IForgotPassword) => {
    setResetFormData(data);
    setShowSpinner(true);
    const response = await userService.requestPasswordReset({
      username: data.username,
      appName,
      redirectUrl: fromUri,
      isActivation: false,
    });
    setShowSpinner(false);

    if (response.ok) {
      setEmailSent(true);
    } else {
      setGenericError('Unsuccessful response when sending password reset email.');
    }
  };

  if (genericError) {
    return <GenericErrorMessage errorMsg={genericError} fromUri={fromUri}></GenericErrorMessage>
  }

  if (showEmailSent) {
    return <CheckEmail email={resetFormData?.email} fromUri={fromUri}><p>Click the link in the email to setup your password</p></CheckEmail>;
  }

  return (<>
    <div className="container">
      <div className="row md-spacer-80 spacer-32">
        <div className="col-lg-6 offset-lg-3 col-xl-4 offset-lg-4">
          <ContentPanel>
            <div className="message-panel__padding forgot-password-panel">
              <RequestPasswordResetForm settingsForApp={settingsForApp} onSubmit={saveForm} submitError={submitError}></RequestPasswordResetForm>
              <div className="row spacer-32">
                <div className="col-lg-12">
                  <a className="link--secondary" href={`/signin?fromURI=${fromUri}`} tabIndex={0}>Back to Sign in</a>
                </div>
              </div>
            </div>
          </ContentPanel>
        </div>
      </div>
    </div >
    <SpinnerOverlay active={showSpinner} />
  </>
  );

}